module.exports = __webpack_public_path__ + "img/astro_on.52769d6a.svg";